import { useMemo } from 'react';

export default function useGetPaymentDropdownOptions(
  maxMonthly: number,
  minCashDown: number
) {
  return useMemo(() => {
    const monthlyOptions: number[] = [];
    const cashDownOptions: number[] = [];

    // Create monthly payment options
    for (let i = 100; i <= maxMonthly; i += 100) {
      monthlyOptions.push(i);
    }
    if (maxMonthly % 100 !== 0) monthlyOptions.push(maxMonthly);

    // Create down payment options
    cashDownOptions.push(minCashDown);
    let nextDownPayment =
      minCashDown === 0 ? 1000 : Math.ceil(minCashDown / 1000) * 1000;
    while (cashDownOptions.length < 10) {
      cashDownOptions.push(nextDownPayment);
      nextDownPayment += 1000;
    }

    return {
      monthlyOptions,
      cashDownOptions
    };
  }, [maxMonthly, minCashDown]);
}
